var _path, _path2, _ellipse, _ellipse2, _rect, _rect2, _path3, _ellipse3, _circle, _circle2, _ellipse4, _ellipse5, _circle3, _circle4, _ellipse6, _ellipse7, _circle5, _circle6, _ellipse8, _ellipse9, _circle7, _circle8, _ellipse10, _circle9, _circle10, _circle11, _circle12, _g, _circle13, _line, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOilMag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 109,
    viewBox: "0 0 77 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 44.2411C13 42.5842 14.3431 41.2411 16 41.2411H23.5H45C46.6569 41.2411 48 42.5842 48 44.2411V106C48 107.657 46.6569 109 45 109H16C14.3431 109 13 107.657 13 106V44.2411Z",
    fill: "#DCCD31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3717 43.986C28.2564 42.1567 28.4606 37.5843 27.7265 35.0463L35.0802 35.4288C33.9143 38.7014 34.5384 41.6988 39.9178 44.8468C34.3407 45.3899 20.2782 45.1445 23.3717 43.986Z",
    fill: "#DCCD31"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.061,
    cy: 34.2209,
    rx: 7.29167,
    ry: 1.22088,
    fill: "#E5B96E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.061,
    cy: 36.6627,
    rx: 7.29167,
    ry: 1.22088,
    fill: "#E5B96E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.7693,
    y: 34.2209,
    width: 14.5833,
    height: 2.44176,
    fill: "#E5B96E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2916,
    y: 51.0081,
    width: 21.875,
    height: 45.1726,
    rx: 2,
    fill: "#FEF3E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8557 74.7723C28.3633 74.7723 27.9312 74.6551 27.5596 74.4208C27.1902 74.1864 26.9014 73.8585 26.6931 73.4371C26.4871 73.0157 26.3841 72.5233 26.3841 71.9598C26.3841 71.3916 26.4871 70.8957 26.6931 70.4719C26.9014 70.0481 27.1902 69.7191 27.5596 69.4847C27.9312 69.2503 28.3633 69.1331 28.8557 69.1331C29.3481 69.1331 29.779 69.2503 30.1483 69.4847C30.52 69.7191 30.8088 70.0481 31.0148 70.4719C31.2231 70.8957 31.3273 71.3916 31.3273 71.9598C31.3273 72.5233 31.2231 73.0157 31.0148 73.4371C30.8088 73.8585 30.52 74.1864 30.1483 74.4208C29.779 74.6551 29.3481 74.7723 28.8557 74.7723ZM28.8557 74.0195C29.2298 74.0195 29.5375 73.9236 29.779 73.7318C30.0205 73.5401 30.1992 73.288 30.3152 72.9755C30.4312 72.663 30.4892 72.3244 30.4892 71.9598C30.4892 71.5952 30.4312 71.2555 30.3152 70.9407C30.1992 70.6258 30.0205 70.3713 29.779 70.1772C29.5375 69.983 29.2298 69.886 28.8557 69.886C28.4817 69.886 28.1739 69.983 27.9324 70.1772C27.6909 70.3713 27.5122 70.6258 27.3962 70.9407C27.2802 71.2555 27.2222 71.5952 27.2222 71.9598C27.2222 72.3244 27.2802 72.663 27.3962 72.9755C27.5122 73.288 27.6909 73.5401 27.9324 73.7318C28.1739 73.9236 28.4817 74.0195 28.8557 74.0195ZM32.6066 74.6587V69.2041H33.4447V74.6587H32.6066ZM33.0327 68.2951C32.8694 68.2951 32.7285 68.2394 32.6102 68.1282C32.4942 68.0169 32.4361 67.8831 32.4361 67.7269C32.4361 67.5706 32.4942 67.4369 32.6102 67.3256C32.7285 67.2143 32.8694 67.1587 33.0327 67.1587C33.1961 67.1587 33.3358 67.2143 33.4518 67.3256C33.5701 67.4369 33.6293 67.5706 33.6293 67.7269C33.6293 67.8831 33.5701 68.0169 33.4518 68.1282C33.3358 68.2394 33.1961 68.2951 33.0327 68.2951ZM35.8177 67.386V74.6587H34.9797V67.386H35.8177Z",
    fill: "#BEAA28"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.8,
    cy: 42.8,
    rx: 2.8,
    ry: 1.4,
    fill: "#868787"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9,
    cy: 42.1,
    r: 2.1,
    fill: "#868787"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1,
    cy: 44.9,
    r: 2.1,
    fill: "#868787"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.9,
    cy: 44.2001,
    rx: 2.1,
    ry: 1.4,
    fill: "#868787"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35,
    cy: 42,
    rx: 2,
    ry: 1,
    fill: "#868787"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 41.5,
    r: 1.5,
    fill: "#868787"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 43.5,
    r: 1.5,
    fill: "#868787"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.5,
    cy: 43,
    rx: 1.5,
    ry: 1,
    fill: "#868787"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23,
    cy: 44,
    rx: 2,
    ry: 1,
    fill: "#868787"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 43.5,
    r: 1.5,
    fill: "#868787"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 45.5,
    r: 1.5,
    fill: "#868787"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.5,
    cy: 45,
    rx: 1.5,
    ry: 1,
    fill: "#868787"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.2,
    cy: 40.2,
    rx: 3.2,
    ry: 1.6,
    fill: "#868787"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.6,
    cy: 39.4,
    r: 2.4,
    fill: "#868787"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.4,
    cy: 42.6,
    r: 2.4,
    fill: "#868787"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.6,
    cy: 41.7999,
    rx: 2.4,
    ry: 1.6,
    fill: "#868787"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 44.5,
    r: 0.5,
    fill: "#868787"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 46.5,
    r: 0.5,
    fill: "#868787"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 44.5,
    r: 0.5,
    fill: "#868787"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 33.5,
    r: 32.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_1369)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_306_1369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 38.3053C5 35.7546 7.07229 33.6869 9.62857 33.6869H21.2H54.3714C56.9278 33.6869 59 35.7546 59 38.3053V133.382C59 135.932 56.9278 138 54.3714 138H9.62857C7.07229 138 5 135.932 5 133.382V38.3053Z",
    fill: "#DCCD31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0021 37.9127C28.5385 35.0964 28.8535 28.0575 27.7209 24.1501L39.0666 24.7391C37.2678 29.7771 38.2307 34.3916 46.5304 39.2378C37.9257 40.0739 16.2292 39.6961 21.0021 37.9127Z",
    fill: "#DCCD31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8655 24.759C39.0787 24.759 44.1155 23.9175 44.1155 22.8795C44.1155 21.8415 39.0787 21 32.8655 21C26.6523 21 21.6155 21.8415 21.6155 22.8795C21.6155 23.9175 26.6523 24.759 32.8655 24.759Z",
    fill: "#E5B96E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8655 28.5181C39.0787 28.5181 44.1155 27.6766 44.1155 26.6385C44.1155 25.6005 39.0787 24.759 32.8655 24.759C26.6523 24.759 21.6155 25.6005 21.6155 26.6385C21.6155 27.6766 26.6523 28.5181 32.8655 28.5181Z",
    fill: "#E5B96E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1154 22.8796H21.6155V26.6387H44.1154V22.8796Z",
    fill: "#E5B96E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9143 48.723H19.3357C17.6315 48.723 16.25 50.1015 16.25 51.802V115.186C16.25 116.887 17.6315 118.265 19.3357 118.265H46.9143C48.6185 118.265 50 116.887 50 115.186V51.802C50 50.1015 48.6185 48.723 46.9143 48.723Z",
    fill: "#FEF3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8628 38.2422C13.2487 38.2422 15.1828 37.2772 15.1828 36.0869C15.1828 34.8966 13.2487 33.9316 10.8628 33.9316C8.47698 33.9316 6.54285 34.8966 6.54285 36.0869C6.54285 37.2772 8.47698 38.2422 10.8628 38.2422Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1029 38.2422C15.8923 38.2422 17.3429 36.7947 17.3429 35.0093C17.3429 33.2238 15.8923 31.7764 14.1029 31.7764C12.3135 31.7764 10.8629 33.2238 10.8629 35.0093C10.8629 36.7947 12.3135 38.2422 14.1029 38.2422Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.78285 42.5526C11.5722 42.5526 13.0228 41.1052 13.0228 39.3197C13.0228 37.5342 11.5722 36.0868 9.78285 36.0868C7.99344 36.0868 6.54285 37.5342 6.54285 39.3197C6.54285 41.1052 7.99344 42.5526 9.78285 42.5526Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1029 40.3973C15.8923 40.3973 17.3429 39.4324 17.3429 38.2421C17.3429 37.0517 15.8923 36.0868 14.1029 36.0868C12.3135 36.0868 10.8629 37.0517 10.8629 38.2421C10.8629 39.4324 12.3135 40.3973 14.1029 40.3973Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9429 36.3947C40.6471 36.3947 42.0286 35.7055 42.0286 34.8553C42.0286 34.005 40.6471 33.3158 38.9429 33.3158C37.2387 33.3158 35.8572 34.005 35.8572 34.8553C35.8572 35.7055 37.2387 36.3947 38.9429 36.3947Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2572 36.3948C42.5353 36.3948 43.5714 35.3609 43.5714 34.0856C43.5714 32.8102 42.5353 31.7764 41.2572 31.7764C39.979 31.7764 38.9429 32.8102 38.9429 34.0856C38.9429 35.3609 39.979 36.3948 41.2572 36.3948Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1715 39.4736C39.4496 39.4736 40.4857 38.4398 40.4857 37.1644C40.4857 35.8891 39.4496 34.8552 38.1715 34.8552C36.8933 34.8552 35.8572 35.8891 35.8572 37.1644C35.8572 38.4398 36.8933 39.4736 38.1715 39.4736Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2572 37.9342C42.5353 37.9342 43.5714 37.2449 43.5714 36.3947C43.5714 35.5445 42.5353 34.8552 41.2572 34.8552C39.979 34.8552 38.9429 35.5445 38.9429 36.3947C38.9429 37.2449 39.979 37.9342 41.2572 37.9342Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4286 39.4737C22.1328 39.4737 23.5143 38.7845 23.5143 37.9342C23.5143 37.084 22.1328 36.3948 20.4286 36.3948C18.7244 36.3948 17.3429 37.084 17.3429 37.9342C17.3429 38.7845 18.7244 39.4737 20.4286 39.4737Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7429 39.4736C24.021 39.4736 25.0572 38.4398 25.0572 37.1644C25.0572 35.8891 24.021 34.8552 22.7429 34.8552C21.4647 34.8552 20.4286 35.8891 20.4286 37.1644C20.4286 38.4398 21.4647 39.4736 22.7429 39.4736Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6572 42.5526C20.9353 42.5526 21.9715 41.5188 21.9715 40.2434C21.9715 38.9681 20.9353 37.9342 19.6572 37.9342C18.379 37.9342 17.3429 38.9681 17.3429 40.2434C17.3429 41.5188 18.379 42.5526 19.6572 42.5526Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7429 41.0132C24.021 41.0132 25.0572 40.3239 25.0572 39.4737C25.0572 38.6234 24.021 37.9342 22.7429 37.9342C21.4647 37.9342 20.4286 38.6234 20.4286 39.4737C20.4286 40.3239 21.4647 41.0132 22.7429 41.0132Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0514 34.5473C52.7781 34.5473 54.9885 33.4445 54.9885 32.0841C54.9885 30.7238 52.7781 29.621 50.0514 29.621C47.3247 29.621 45.1143 30.7238 45.1143 32.0841C45.1143 33.4445 47.3247 34.5473 50.0514 34.5473Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7542 34.5473C55.7993 34.5473 57.4571 32.8931 57.4571 30.8526C57.4571 28.812 55.7993 27.1578 53.7542 27.1578C51.7092 27.1578 50.0514 28.812 50.0514 30.8526C50.0514 32.8931 51.7092 34.5473 53.7542 34.5473Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8171 39.4736C50.8621 39.4736 52.52 37.8194 52.52 35.7788C52.52 33.7383 50.8621 32.0841 48.8171 32.0841C46.7721 32.0841 45.1143 33.7383 45.1143 35.7788C45.1143 37.8194 46.7721 39.4736 48.8171 39.4736Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7542 37.0104C55.7993 37.0104 57.4571 35.9076 57.4571 34.5473C57.4571 33.1869 55.7993 32.0841 53.7542 32.0841C51.7092 32.0841 50.0514 33.1869 50.0514 34.5473C50.0514 35.9076 51.7092 37.0104 53.7542 37.0104Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3714 39.4737C27.7975 39.4737 28.1428 39.1291 28.1428 38.7039C28.1428 38.2788 27.7975 37.9342 27.3714 37.9342C26.9454 37.9342 26.6 38.2788 26.6 38.7039C26.6 39.1291 26.9454 39.4737 27.3714 39.4737Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8286 42.5527C26.2546 42.5527 26.6 42.208 26.6 41.7829C26.6 41.3578 26.2546 41.0132 25.8286 41.0132C25.4025 41.0132 25.0571 41.3578 25.0571 41.7829C25.0571 42.208 25.4025 42.5527 25.8286 42.5527Z",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2286 39.4737C58.6546 39.4737 59 39.1291 59 38.7039C59 38.2788 58.6546 37.9342 58.2286 37.9342C57.8025 37.9342 57.4572 38.2788 57.4572 38.7039C57.4572 39.1291 57.8025 39.4737 58.2286 39.4737Z",
    fill: "#868787"
  })))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 33.5,
    r: 31.5,
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 56.4142,
    y1: 55,
    x2: 76,
    y2: 74.5858,
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_1369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_306_1369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 117,
    fill: "white",
    transform: "translate(5 21)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilMag);
export default __webpack_public_path__ + "static/media/oil_mag.90a953b379ed4b3982a445bb9b352816.svg";
export { ForwardRef as ReactComponent };